export default {
  methods: {
    createPhasesFeedersButtons(array = []) {
      return array.reduce(
        (electricalButtons, phase) => {
          const { phaseNumber, feeders } = phase;
          const phaseName = phaseNumber === 0 ? 'N' : `L${phaseNumber}`;
          const phaseObject = {
            label: phaseName,
            value: {
              group: 'phase',
              value: phaseNumber
            }
          };

          // eslint-disable-next-line no-param-reassign
          electricalButtons.phases[phaseNumber] = phaseObject;

          feeders.forEach(feeder => {
            const { feederNumber } = feeder;

            if (electricalButtons.feeders[feederNumber]) return false;

            const feederName = parseInt(feederNumber, 10) === 0 ? 'TX' : `Feeder ${feederNumber}`;
            const feederObject = {
              label: feederName,
              value: {
                group: 'feeder',
                value: feederNumber
              }
            };
            // eslint-disable-next-line no-param-reassign
            electricalButtons.feeders[feederNumber] = feederObject;

            return true;
          });
          return electricalButtons;
        },
        { phases: {}, feeders: {} }
      );
    }
  }
};
